import React from 'react';
import dynamic from 'next/dynamic';

import { ProductPageTemplate } from 'src/templates';
import { ProductPageHeader } from 'src/components/headers/ProductPageHeader';
import Features from 'src/components/features';
import { CredibilityCarousel as Credibility } from 'src/components/Credibility';
import FooterExtension from 'src/components/footer-extension';

import { Locales } from 'src/lib/constants';

// data
import {
  metaData,
  productHeaderData,
  featuresData,
  interactiveData,
  credibilityData,
  footerExtensionData,
} from 'src/store/en-eu/products/identity';

const InteractiveData = dynamic(
  () => {
    return import('src/components/Surfaces/InteractiveData/InteractiveData');
  },
  {
    ssr: false,
  },
);

const EUProductIdentity = ({ locale = Locales.EN_EU }) => {
  return (
    <ProductPageTemplate
      fields={{ components: [], ...metaData }}
      locale={locale}
    >
      <ProductPageHeader {...productHeaderData} />
      <Features {...featuresData} />
      <InteractiveData {...interactiveData} />
      <Credibility {...credibilityData} />
      <FooterExtension {...footerExtensionData} />
    </ProductPageTemplate>
  );
};

export default EUProductIdentity;
